import React from "react"
import {Link, useParams} from "react-router-dom"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"
import {useAsyncResult} from "../../hooks/useAsyncResult"
import {useAccessToken} from "../../services/auth"
import {getManagedSolutionsApplicationForm} from "../../resources/managedSolutions"
import {useRefreshToken} from "../../hooks/useRefreshToken"
import TitleBar from "../../components/TitleBar/TitleBar"
import {MainSection} from "../../containers/MainSection/MainSection"
import {startCase} from "lodash"
import moment from "moment"
import HorizontalField from "../../components/HorizontalField/HorizontalField"

export default function ManagedSolutionsApplicationFormPage() {
	const {applicationFormId = ""} = useParams<{applicationFormId: string}>()
	const accessToken = useAccessToken()
	const [refreshToken, refresh] = useRefreshToken()
	const asyncResult = useAsyncResult(
		() => getManagedSolutionsApplicationForm(accessToken, applicationFormId),
		[refreshToken, applicationFormId]
	)

	return (
		<>
			<AsyncResultComponent asyncResult={asyncResult} refresh={refresh}>
				{({value: applicationForm}) => {
					const {attributes, relationships} = applicationForm.data
					const stageDisplay = attributes.stage ? startCase(attributes.stage) : undefined
					const createdAt = attributes.createdAt ? moment(attributes.createdAt).format("L LT") : undefined
					const updatedAt = attributes.updatedAt ? moment(attributes.updatedAt).format("L LT") : undefined
					const applicationId = relationships?.application?.data?.id

					return (
						<>
							<TitleBar
								title={`Application Form ${applicationForm.data.id}`}
								breadcrumbs={[{text: "Application Forms", path: "/managed-solutions/application-forms"}]}
								meta={stageDisplay ? [{text: stageDisplay}] : undefined}
							/>

							<MainSection>
								<div className="columns">
									<div className="column is-4">
										<div className="card">
											<div className="card-header">
												<p className="card-header-title">Application Form Details</p>
											</div>
											<div className="card-content">
												<HorizontalField label="Application Form ID">
													<input type="text" className="input is-static" readOnly value={applicationForm.data.id} />
												</HorizontalField>
												{stageDisplay && (
													<HorizontalField label="Stage">
														<input type="text" className="input is-static" readOnly value={stageDisplay} />
													</HorizontalField>
												)}
												{applicationId && (
													<HorizontalField label="Application">
														<Link className="link" to={`/managed-solutions/applications/${applicationId}`}>
															{applicationId}
														</Link>
													</HorizontalField>
												)}
												{createdAt && (
													<HorizontalField label="Created At">
														<input type="text" className="input is-static" readOnly value={createdAt} />
													</HorizontalField>
												)}
												{updatedAt && (
													<HorizontalField label="Updated At">
														<input type="text" className="input is-static" readOnly value={updatedAt} />
													</HorizontalField>
												)}
												<HorizontalField label="User IDs">
													<div>
														{attributes.userIds.map((userId, index) => (
															<div key={index} style={{marginBottom: "0.5rem"}}>
																{userId}
															</div>
														))}
													</div>
												</HorizontalField>
											</div>
										</div>
									</div>
								</div>
							</MainSection>
						</>
					)
				}}
			</AsyncResultComponent>
		</>
	)
}
